"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("mktDashboardIndexSummary", function (fixingService, chartUtils, $numberFormat, $dateFormat, contextService, mktHistoryUtils, mktChartUtils, $translate, $q) {
  return {
    restrict: "E",
    scope: {
      index: "<",
      editing: "<",
      onDelete: "<",
      onMove: "<"
    },
    replace: true,
    controllerAs: "$ctrl",
    template: require("./mktDashboardIndexSummary.html"),
    controller: function controller($scope) {
      var getAxis = mktChartUtils.getAxis,
        getIndiceTypes = mktChartUtils.getIndiceTypes,
        getReferenceIndexType = mktChartUtils.getReferenceIndexType,
        getReferenceLabel = mktChartUtils.getReferenceLabel;
      var ctrl = this;
      ctrl.state = {};
      ctrl.$onInit = function () {
        $scope.$watch("index", onIndexChange);
      };
      function onIndexChange() {
        ctrl.index = $scope.index;
        if (ctrl.index == null) {
          return;
        }
        fixingService.getReferenceLabel(ctrl.index.reference).then(function (label) {
          ctrl.state.referenceLabel = label;
          var fixing = ctrl.index.fixing;
          var fixing1M = ctrl.index.fixing1M;
          var fixing3M = ctrl.index.fixing3M;
          var fixing1Y = ctrl.index.fixing1Y;
          if (fixing && fixing1M) {
            ctrl.state.var1M = fixing1M.valeur === 0.0 ? null : (fixing.valeur - fixing1M.valeur) / fixing1M.valeur;
          }
          if (fixing && fixing3M) {
            ctrl.state.var3M = fixing3M.valeur === 0.0 ? null : (fixing.valeur - fixing3M.valeur) / fixing3M.valeur;
          }
          if (fixing && fixing1Y) {
            ctrl.state.var1Y = fixing1Y.valeur === 0.0 ? null : (fixing.valeur - fixing1Y.valeur) / fixing1Y.valeur;
          }
          ctrl.state.chartConfig = buildChartConfig();
          getIndexChartData(ctrl.index).then(function (chartData) {
            ctrl.state.chartConfig.series = chartData;
          });
          ctrl.state.value = fixing ? formatValue(fixing) : "N/A";
        });
      }
      function formatValue(fixing) {
        if (ctrl.index.indexType === 'TAUX') {
          return $numberFormat.percentage(fixing.valeur, 2);
        } else {
          return $numberFormat.number(fixing.valeur, 2);
        }
      }
      function getIndexChartData(index) {
        return fixingService.getHistory(index.reference, {
          historique: 1,
          forward: 1,
          nbDonneeMax: 200
        }).then(function (indexHistory) {
          return fixingService.getReferenceLabel(index.reference).then(function (label) {
            return [{
              name: label,
              data: chartUtils.mapAndFilter(indexHistory, "date", "valeur")
            }];
          });
        });
      }
      function buildChartConfig() {
        var index = ctrl.index;
        var typeIndex = index.indexType;
        var labelFormatter;
        var tooltipFormatter;
        if (typeIndex === 'TAUX') {
          labelFormatter = function labelFormatter() {
            return $numberFormat.percentage(this.value, 1);
          };
          tooltipFormatter = function tooltipFormatter() {
            return '<span>' + $dateFormat.date(this.x) + '</span> : <b>' + $numberFormat.percentage(this.y, 2) + '</b>';
          };
        } else {
          labelFormatter = function labelFormatter() {
            return $numberFormat.number(this.value, 2);
          };
          tooltipFormatter = function tooltipFormatter() {
            return '<span>' + $dateFormat.date(this.x) + '</span> : <b>' + $numberFormat.number(this.y, 2) + '</b>';
          };
        }
        var config = {
          options: {
            chart: {
              spacingLeft: 2,
              spacingRight: 0,
              spacingTop: 5,
              spacingBottom: 5,
              zoomType: 'x',
              height: 200
            },
            plotOptions: {
              series: {
                pointInterval: 24 * 3600 * 1000,
                turboThreshold: 0,
                animation: false,
                color: '#2f7ed8'
              }
            },
            xAxis: {
              type: 'datetime',
              plotLines: chartUtils.getDateMarchePlotLine(contextService)
            },
            yAxis: {
              startOnTick: false,
              labels: {
                formatter: labelFormatter
              }
            },
            tooltip: {
              formatter: tooltipFormatter
            },
            legend: {
              enabled: false
            }
          },
          fsOptions: {
            legend: {
              enabled: true
            },
            title: {
              text: chartUtils.tooltipElement(ctrl.state.referenceLabel, {
                color: chartUtils.getGraphColor(0)
              })
            },
            navigator: {
              enabled: true,
              adaptToUpdatedData: false
            },
            scrollbar: {
              liveRedraw: false
            },
            rangeSelector: {
              enabled: true
            },
            yAxis: {
              labels: {
                formatter: function formatter() {
                  return typeIndex === "TAUX" ? $numberFormat.percentage(this.value, 2) : $numberFormat.number(this.value, 2);
                },
                style: {
                  color: chartUtils.getGraphColor(0)
                }
              },
              title: {
                text: mktHistoryUtils.getIndexTypeAxisLabel(typeIndex),
                style: {
                  color: chartUtils.getGraphColor(0)
                }
              }
            }
          }
        };
        return config;
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mktDashboardIndexSummary.js
// module id = 2842
// module chunks = 13